export const createCustomer = `
    mutation createCustomer($input: CreateCustomerInput!) {
        createCustomer(input:$input) {
            id
            name
            description      
            status 
            contactInfo {
              email
              phone
              website
            }
            billingInfo {
              billingProviderId
              billingProviderRecordId
              billingZip
            }
            paymentInfo {
              currency
              paymentMethod
            }
            created
            createdByUsername
            createdByUser {
                name
                givenName
                familyName
                email
            }
    }
}`;

export const updateCustomer = `
    mutation updateCustomer($input: UpdateCustomerInput!) {
        updateCustomer(input:$input){
            id
            name
            description
            status  
            contactInfo {
              email
              phone
              website
            }
            billingInfo {
              billingProviderId
              billingProviderRecordId
              billingZip
            }
            paymentInfo {
              currency
              paymentMethod
            }
            created
            createdByUsername
            createdByUser {
                name
                givenName
                familyName
                email
            }
            updated       
            updatedByUsername
        }
}`;

export const deleteCustomer = `
    mutation deleteCustomer($input: DeleteCustomerInput!) {
        deleteCustomer(input:$input) 
}`;
